import { Component } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  Loading
} from 'ionic-angular';
import * as Enumerable from 'linq';
import { NavEntity } from '../../models';
import { StarmsClientProvider } from '../../providers/starms-client/starms-client';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ApplicationApiProvider } from '../../providers/application-api/application-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'page-kpi-power-gen',
  templateUrl: 'kpi-power-gen.html',
})
export class KpiPowerGenPage {
  nav: NavEntity;
  selectedKpiPage: string;
  timeRange: any;
  chartDataSource: any;
  loader: Loading;
  availableData = true;
  time: any;
  subscription: Subscription = new Subscription();
  hasPowerGenerated = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private starms: StarmsClientProvider,
    private appApi: ApplicationApiProvider
  ) {}

  ionViewDidLoad() {
    this.time = this.navParams.get('time');
    if (this.navParams.get('kpi') === 'power') {
      this.hasPowerGenerated = true;
      this.selectedKpiPage = 'PwrGen';
    } else {
      this.selectedKpiPage = this.navParams.get('kpi');
    }
    this.getChartData();
  }

  getChartData() {
    this.loader = this.loadingCtrl.create({
      content: 'Please wait',
      enableBackdropDismiss: true
    });
    this.loader.present();

    this.subscription = forkJoin(
      this.starms.get(['kpis', this.navParams.get('entity').getType() + 's', this.navParams.get('entity').getId(), 'daily'], {
        from: this.time.from,
        to: this.time.to,
        kpitype: this.selectedKpiPage
      }),
      this.starms.get(['kpis', this.navParams.get('entity').getType() + 's', this.navParams.get('entity').getId(), 'daily'], {
        from: this.time.prevFrom,
        to: this.time.prevTo,
        kpitype: this.selectedKpiPage
      })
    ).subscribe(([result, previous]) => {
        if (result.length === 0) {
          this.availableData = false;
          this.loader.dismiss();
        } else {
          this.availableData = true;
          // Create the char data source used by the highcharts object
          let chartDataSource: any = {};
          chartDataSource.type = 'column';
          chartDataSource.series = [];
          chartDataSource.avgVal = -1;
          let dateArray = Enumerable.from(result)
            .select(function(x) {
              return x['siteDate'];
            })
            .distinct()
            .toArray();
          chartDataSource.categories = Enumerable.from(dateArray).orderBy(x => x).toArray();
          let serie = { name: 'Current period', color: '#641e8c', data: [] };

          // tslint:disable-next-line:curly
          for (let k in dateArray)
            serie.data.push(
              Enumerable.from(result)
                .where(function(x) {
                  return x['siteDate'] === dateArray[k];
                })
                .average(function(x) {
                  return x.value;
                })
            );
          chartDataSource.series.push(serie);
          // if (previous.length === 0) {
          // } else {
          //   chartDataSource.series.push({
          //     name: 'Previous period average',
          //     color: '#EB780A',
          //     data: []
          //   });
          //   chartDataSource.avgVal =
          //     Enumerable.from(previous).average(x => x['value']) / 24;
          // }
        this.loader.dismiss();
        this.chartDataSource = chartDataSource;
      }
    }, () => {
      this.appApi.showToast('Error while obtaining kpi data');
      this.loader.dismiss();
    });
  }

  kpiPageChanged(event?: any): void {
    this.subscription.unsubscribe();
    this.chartDataSource = [];
    this.getChartData();
  }

  close(): void {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/kpi-power-gen/kpi-power-gen.ts